import * as React from 'react';
import { createComponent } from '../../../react/components/core/create-component.js';
import { useId } from '../../../react/hooks/use-id.js';
import { useLegacyModalDialogContext } from './legacy.modal-dialog.context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @deprecated Use new Modal/Dialog and its sub-components instead
 */ const LegacyModalDialogTitle = createComponent({
    root: 'h2',
    displayName: 'LegacyModalDialogTitle',
    propConfig: {
        derivedProps (props) {
            const { id: customId  } = props;
            const id = useId(customId);
            const ctx = useLegacyModalDialogContext();
            React.useEffect(()=>{
                ctx.setTitleId(id);
                // when the component unmounts, tell the parent that it is no longer labeled
                return ()=>ctx.setTitleId(undefined);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [
                id,
                ctx.setTitleId
            ]);
            return {
                id
            };
        },
        processProps (props, derivedProps) {
            return _object_spread_props(_object_spread({}, props), {
                id: derivedProps.id || undefined
            });
        },
        classNames: [
            'swan-legacy-modal-dialog-title'
        ]
    }
});

export { LegacyModalDialogTitle };
